import { Controller } from "@hotwired/stimulus"

// One open question at a time per category.
export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    event.preventDefault()
    const clicked = event.currentTarget.closest(".faq-item")
    const wasOpen = clicked.classList.contains("is-open")

    this.itemTargets.forEach(item => {
      item.classList.remove("is-open")
      this.setIcon(item, "+")
    })

    if (!wasOpen) {
      clicked.classList.add("is-open")
      this.setIcon(clicked, "−")
    }
  }

  setIcon(item, glyph) {
    const icon = item.querySelector(".faq-question-icon")
    if (icon) icon.textContent = glyph
  }
}
